import StaticLayoutMDX, { Twitter } from "../../../../src/templates/static-page-mdx.js";
import React from 'react';
export default {
  StaticLayoutMDX,
  Twitter,
  React
};